import { render, staticRenderFns } from "./DashboardSalesAgentRankingTable.vue?vue&type=template&id=2befcb96"
import script from "./DashboardSalesAgentRankingTable.vue?vue&type=script&lang=ts"
export * from "./DashboardSalesAgentRankingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports